/* eslint-disable arrow-body-style */
// @flow
import React, { useState } from 'react';
import { MotionConfig } from 'framer-motion/dist/framer-motion';
import type {
  ToggleProps,
  NavigationItem,
  BurgerProps,
  ExternalProps,
} from '../types';
import Steps from './Steps';
import BurgerContentStart from './BurgerContentStart';
import BurgerContentSubmenu from './BurgerContentSubmenu';
import BurgerContentMinistry from './BurgerContentMinistry';
import BurgerContentLanguage from './BurgerContentLanguage';

const BurgerContent = (props: ExternalProps): React$MixedElement => {
  const [stepKey, setStepKey] = useState('start');
  const [activeItem, setActiveItem] = useState<NavigationItem | null>(null);

  const getStep = () => {
    const sharedProps = {
      ...props,
      setStepKey,
      setActiveItem,
      activeItem,
    };
    if (stepKey === 'submenu') {
      return <BurgerContentSubmenu {...sharedProps} />;
    }

    if (stepKey === 'ministry') {
      return <BurgerContentMinistry {...sharedProps} />;
    }

    if (stepKey === 'languages') {
      return <BurgerContentLanguage {...sharedProps} />;
    }

    return <BurgerContentStart {...sharedProps} />;
  };

  return (
    <div className="burger">
      <MotionConfig reducedMotion="user">
        <Steps stepKey={stepKey}>{getStep()}</Steps>
      </MotionConfig>
    </div>
  );
};

export default BurgerContent;
